// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1-mPq","title":"AfterFrontImage_title__3oQmk"};